import {ApiBuilder} from "..";

const resetCredentials = (builder: ApiBuilder) =>
  builder.mutation<void, {userId: string; username: string; password: string}>({
    query: ({userId, username, password}) => ({
      url: `/api/user/reset-credentials/${userId}`,
      method: "PUT",
      body: {username, password},
    }),
  });

export {resetCredentials};
